import {
    MODAL_COSTCENTER_KEY_VALUE,
    MODAL_COSTCENTER_INPUT_SEARCH,
    MODAL_COSTCENTER_SET_RESULT
} 
from '../actions/actionTypes';

const initialState = {
    refKey: null,
};

function ModalCostCenterRedux(state = initialState, action) {
    
    switch (action.type) {
        case MODAL_COSTCENTER_KEY_VALUE:
            return {
                ...state,
                refKey : action.payload
            };
        default:
            return state;
    }
}

export default ModalCostCenterRedux;